import {
  axiosApplication,
  axiosAuthority,
  axiosInstance
} from "@config/axiosConfig";
import {
  SendEmailOtpPayload,
  SendOtpPayload,
  VerifyEmailOtpPayload,
  VerifyOtpPayload
} from "../types";

// API endpoints for login service
export const sendOtp = async (payload: SendOtpPayload) => {
  return await axiosInstance.post("login/send-otp", payload);
};

export const verifyOtp = async (payload: VerifyOtpPayload) => {
  return await axiosInstance.post("login/verify-otp", payload);
};

export const sendEmailOTP = async (payload: SendEmailOtpPayload) => {
  return await axiosInstance.post("login/send-email-otp", payload);
};

export const verifyEmailOTP = async (payload: VerifyEmailOtpPayload) => {
  return await axiosInstance.post("login/verify-email-otp", payload);
};

export const getPublicComments = async (payload: any) => {
  return await axiosApplication.post("/demand-draft-list", payload);
};

export const logout = async () => {
  return await axiosInstance.post("login/log-out");
};
